import React from 'react';
import { ADDRESS_LABELS, ADDRESS_NAMES } from './types';
import { FormInputWrapper, PostcodeInput, TextInput } from 'form/infrastructure/reactHookForm';

type Props = {
  newUi?: boolean;
};

const Address: React.FC<Props> = ({ newUi }) => {
  return (
    <>
      <FormInputWrapper title={ADDRESS_LABELS.ADDRESS_LINE_1} name={ADDRESS_NAMES.ADDRESS_LINE_1} newUi={newUi}>
        <TextInput newUi={newUi} />
      </FormInputWrapper>

      <FormInputWrapper
        title={ADDRESS_LABELS.ADDRESS_LINE_2}
        name={ADDRESS_NAMES.ADDRESS_LINE_2}
        isOptional={true}
        newUi={newUi}>
        <TextInput newUi={newUi} />
      </FormInputWrapper>

      <FormInputWrapper
        title={ADDRESS_LABELS.ADDRESS_LINE_3}
        name={ADDRESS_NAMES.ADDRESS_LINE_3}
        isOptional={true}
        newUi={newUi}>
        <TextInput newUi={newUi} />
      </FormInputWrapper>

      <FormInputWrapper title={ADDRESS_LABELS.CITY} name={ADDRESS_NAMES.CITY} newUi={newUi}>
        <TextInput newUi={newUi} />
      </FormInputWrapper>

      <FormInputWrapper title={ADDRESS_LABELS.COUNTY} name={ADDRESS_NAMES.COUNTY} isOptional={true} newUi={newUi}>
        <TextInput newUi={newUi} />
      </FormInputWrapper>

      <FormInputWrapper title={ADDRESS_LABELS.POSTCODE} name={ADDRESS_NAMES.POSTCODE} newUi={newUi}>
        <PostcodeInput newUi={newUi} />
      </FormInputWrapper>
    </>
  );
};

export default Address;
